import DashboardLayout from '@/views/Dashboard/Layout/DashboardLayout.vue'
// GeneralViews
import Auth from '@/views/GeneralViews/Auth.vue'
import NotFound from '@/views/GeneralViews/NotFoundPage.vue'
import Dashboard from '@/views/Dashboard/General/Dashboard/Index.vue'

// General section
import IP_addressing from '@/views/Dashboard/General/IP-addressing/Index.vue'
import IP_address from '@/views/Dashboard/General/IP-address/Index.vue'
import Settings from '@/views/Dashboard/General/Settings/Index.vue'
import ProxyServers from '@/views/Dashboard/General/ProxyServers/Index.vue'
import UserManagement from '@/views/Dashboard/General/UserManagement/Index.vue'
import User from '@/views/Dashboard/General/User/Index.vue'
import Servers from '@/views/Dashboard/General/ServerList/Index.vue'
import Server from '@/views/Dashboard/General/Server/Index.vue'
import TaskList from '@/views/Dashboard/General/TaskList/Index.vue'
import Notification from '@/views/Dashboard/General/Notification/Index.vue'
import Documentation from "@/views/Dashboard/General/Documentation/Index.vue";

import Supports from '@/views/Dashboard/General/Supports/Supports.vue'
import Ticket from "@/views/Dashboard/General/Ticket/Ticket.vue";
import Utilities from '@/views/Dashboard/General/Utilities/Index.vue'

import ModelsList from '@/views/Dashboard/General/ModelsList/Index.vue'

import ProjectList from "@/views/Dashboard/General/ProjectList/Index.vue";
import Project from "@/views/Dashboard/General/Project/Index.vue";

import ClientList from '@/views/Dashboard/General/ClientList/Index.vue'
import Client from "@/views/Dashboard/General/Client/Index.vue";

import Production from "@/views/Dashboard/General/Production/Index.vue";
import ClientOrder from "@/views/Dashboard/General/ClientOrder/Index.vue";
import Specification from "@/views/Dashboard/General/Specification/Specification.vue";

import ClientRequestList from "@/views/Dashboard/General/ClientRequestList/Index.vue";
import ClientRequest from "@/views/Dashboard/General/ClientRequest/Index.vue";

import SnapshotsList from "@/views/Dashboard/General/SnapshotList/Index.vue";

import StorageList from "@/views/Dashboard/General/StorageList/Index.vue";

// Device section
import Device from '@/views/Dashboard/General/Device/Index.vue'
import DeviceGroups from '@/views/Dashboard/General/DeviceGroups/Index.vue'
import DeviceList from '@/views/Dashboard/General/DeviceList/Index.vue'
import SimCardDevices from '@/views/Dashboard/General/SimCardDevices/Index.vue'
import SimCardDevicesGroups from '@/views/Dashboard/General/SimCardDevicesGroup/Index.vue'
import SimCardDevicesList from '@/views/Dashboard/General/SimCardDevicesList/Index.vue'

// Old SimcardProfile section
import CommunicationManagement from '@/views/Dashboard/General/CommunicationManagement/Index.vue'

import Tariffication from '@/views/Dashboard/General/Tariffication/Index.vue'
import Services from '@/views/Dashboard/General/Services/Services.vue'

import Tariff from '@/views/Dashboard/General/Tariff/Index.vue'
import TrafficPacketList from '@/views/Dashboard/General/TrafficPacketList/Index.vue'
import TariffedDevice from '@/views/Dashboard/General/TariffedDevice/Index.vue'

// SimcardProfile sectionR
import SimCardProfile from '@/views/Dashboard/General/SimCardProfile/Index.vue'
import SimCardProfileList from '@/views/Dashboard/General/SimCardProfileList/Index.vue'

import SimTaskList from "@/views/Dashboard/General/SimTaskList/SimTaskList.vue";
import SimTask from "@/views/Dashboard/General/SimTask/SimTask.vue";

//EsimProfile section
import EsimProfile from '@/views/Dashboard/General/EsimProfile/Index.vue'
import EsimProfileList from '@/views/Dashboard/General/EsimProfileList/Index.vue'

//CustomDeviceList
import CustomDeviceList from '@/views/Dashboard/General/CustomDeviceList/Index.vue'

//RemoteSim
import RemoteSim from "@/views/Dashboard/General/RemoteSim/Index.vue";

//BankPayment
import BankPaymentList from "@/views/Dashboard/General/BankPaymentList/Index.vue";
import BankPayment from "@/views/Dashboard/General/BankPayment/Index.vue";

//ClientInvoice
import InvoiceList from "@/views/Dashboard/General/InvoiceList/Index.vue";
import Invoice from "@/views/Dashboard/General/Invoice/Index.vue";

//Airalo
import AiraloList from "@/views/Dashboard/General/AiraloList/Index.vue";
import Airalo from "@/views/Dashboard/General/Airalo/Index.vue";

//Diadoc
import Diadoc from "@/views/Dashboard/General/Diadoc/Diadoc.vue";
import RpcTemplate from "@/views/Dashboard/General/RpcTemplate/RpcTemplate.vue";
import Apn from "@/views/Dashboard/General/Apn/Apn.vue";
import DiadocDocument from "@/views/Dashboard/General/DiadocDocument/DiadocDocument.vue";

const MyRoute = {
  def: function() {
    return [
      { path: '/auth', name: 'auth', component: Auth },
      { path: '/notfound', component: NotFound, name: 'notfound' },
      { path: '*', component: NotFound },
      {
        path: '/',
        redirect: '/device_list'
      },
    ]
  },


  user: function() {
    const userPath = [
      {
        path: '/modem',
        redirect: '/device'
      },
      {
        path: '/modem/:device_id',
        redirect: '/device/:device_id'
      },
      {
        path: '/modem/:device_id/:device_section',
        redirect: '/device/:device_id/:device_section'
      },
      {
        path: '/modem_list',
        redirect: '/device_list'
      },
      {
        path: '/clients',
        redirect: '/client_list'
      },
      {
        path: '/modem_groups/:device_group_id',
        redirect: '/device_groups/:device_group_id'
      },
      {
        path: '/device_group/:device_group_id',
        redirect: '/device_list',
      },
      {
        path: '/simcard_devices_group/:simcard_devices_group_id',
        redirect: '/simcard_devices_list',
      },
      {
        path: '/usermanagment/:user_management_section',
        redirect: '/user_management/:user_management_section',
      },
      //Redirect_END

      {
        path: '/device/:device_id',
        name: 'device',
        redirect: '/device/:device_id/profile',
        access_list: [],
        component: Device,
        children: [
          {
            name: 'device_section',
            path: '/device/:device_id/:device_section',
            props: true,
            component: Device
          },
          {
            name: 'device_section_zero',
            path: ':device_section/:to_zero',
            component: Device
          }
        ]
      },
      {
        path: '/device_list',
        name: 'device_list',
        props: true,
        component: DeviceList
      },
      {
        path: '/device_groups',
        name: 'device_groups',
        props: true,
        component: DeviceGroups
      },

      {
        path: '/dashboard',
        name: 'dashboard',
        redirect: '/dashboard/map',
        component: Dashboard,
        children: [
          {
            path: '/dashboard/:dashboard_section',
            name: 'dashboard_section',
            component: Dashboard
          }
        ]
      },
      {
        path: '/server-list',
        name: 'server-list',
        redirect: '/server-list/list',
        component: Servers,
        children: [
          {
            name: 'servers_section',
            props: true,
            path: '/server-list/:servers_section',
            component: Servers
          }
        ]
      },
      {
        path: '/server/:server_id',
        name: 'server_id',
        redirect: '/server/:server_id/info',
        component: Server,
        children: [
          {
            name: 'server_section',
            path: '/server/:server_id/:server_section',
            props: true,
            component: Server
          }
        ]
      },
      {
        path: '/supports',
        name: 'supports',
        component: Supports,
        redirect: '/supports/ticket_list',
        children: [
          {
            name: 'supports_section',
            props: true,
            path: '/supports/:supports_section',
            component: Supports
          }
        ]
      },

      {
        path: '/ticket/:ticket_id',
        name: 'ticket_id',
        redirect: '/ticket/:ticket_id/info',
        component: Ticket,
        children: [
          {
            name: 'ticket_section',
            path: '/ticket/:ticket_id/:ticket_section',
            props: true,
            component: Ticket
          }
        ]
      },
      {
        path: '/custom_device_list',
        name: 'custom_device_list',
        component: CustomDeviceList
      },
      {
        path: '/task_list',
        name: 'task_list',
        redirect: '/task_list/mass_rpc',
        component: TaskList,
        children: [
          {
            name: 'task_list_section',
            path: '/task_list/:task_list_section',
            component: TaskList
          }
        ]
      },
      {
        name: 'rpc_template',
        path: '/rpc_template/:rpc_template_id',
        redirect: '/rpc_template/:rpc_template_id/info',
        component: RpcTemplate,
        children: [
          {
            name: 'rpc_template_section',
            path: '/rpc_template/:rpc_template_id/:rpc_template_section',
            component: RpcTemplate
          }
        ]
      },
      {
        name: 'apn',
        path: '/apn/:apn_id',
        redirect: '/apn/:apn_id/info',
        component: Apn,
        children: [
          {
            name: 'apn_section',
            path: '/apn/:apn_id/:apn_section',
            component: Apn
          }
        ]
      },
      {
        path: '/models_list',
        name: 'models_list',
        props: true,
        component: ModelsList,
        redirect: '/models_list/articles',
        children: [
          {
            name: 'models_list_section',
            path: '/models_list/:models_list_section',
            component: ModelsList
          },
        ]
      },
      {
        path: '/user_management',
        name: 'user_management',
        redirect: '/user_management/users',
        component: UserManagement,
        children: [
          {
            name: 'user_management_section',
            path: '/user_management/:user_management_section',
            props: true,
            component: UserManagement,
            children: [
              {
                name: 'user_management_section_id',
                path: '/user_management/:user_management_section/:user_id',
                component: UserManagement
              }
            ]
          }
        ]
      },
      {
        path: '/user/:user_id',
        name: 'user_id',
        redirect: '/user/:user_id/info',
        component: User,
        children: [
          {
            name: 'user_section',
            path: '/user/:user_id/:user_section',
            props: true,
            component: User
          }
        ]
      },
      {
        path: '/ip_addressing',
        name: 'ip_addressing',
        redirect: '/ip_addressing/list',
        component: IP_addressing,
        children: [
          {
            name: 'ip_addressing_section',
            path: '/ip_addressing/:ip_addressing_section',
            component: IP_addressing
          },
        ]
      },
      {
        path: '/ip_address/:ip_address_id',
        name: 'ip_address',
        redirect: '/ip_address/:ip_address_id/info',
        component: IP_address,
        children: [
          {
            name: 'ip_address_section',
            path: '/ip_address/:ip_address_id/:ip_address_section',
            component: IP_address
          }
        ]
      },
      {
        path: '/client_list',
        name: 'client_list',
        props: true,
        component: ClientList,
        redirect: '/client_list/clients',
        children: [
          {
            path: '/client_list/:client_list_section',
            name: 'client_list_section',
            component: ClientList
          }
        ]
      },
      {
        path: '/client/:client_id',
        name: 'client',
        redirect: '/client/:client_id/info',
        component: Client,
        children: [
          {
            name: 'client_section',
            path: '/client/:client_id/:client_section',
            component: Client
          }
        ]
      },

      {
        path: '/production',
        name: 'production',
        props: true,
        redirect: '/production/order_list',
        component: Production,
        children: [
          {
            name: 'production_section',
            path: '/production/:production_section',
            props: true,
            component: Production,
          },
        ]
      },

      {
        path: '/client_order/:client_order_id',
        name: 'client_order',
        redirect: '/client_order/:client_order_id/info',
        component: ClientOrder,
        children: [
          {
            name: 'client_order_section',
            path: '/client_order/:client_order_id/:client_order_section',
            component: ClientOrder
          }
        ]
      },

      {
        path: '/specification/:specification_id',
        name: 'specification',
        redirect: '/specification/:specification_id/info',
        component: Specification,
        children: [
          {
            name: 'specification_section',
            path: '/specification/:specification_id/:specification_section',
            component: Specification
          }
        ]
      },

      {
        path: '/client_request_list',
        name: 'client_request_list',
        component: ClientRequestList,
        redirect: '/client_request_list/request_list',
        children: [
          {
            name: 'client_request_list_section',
            props: true,
            path: '/client_request_list/:client_request_list_section',
            component: ClientRequestList
          },
        ]
      },

      {
        path: '/client_request/:client_request_id',
        name: 'client_request',
        redirect: '/client_request/:client_request_id/info',
        component: ClientRequest,
        children: [
          {
            name: 'client_request_section',
            path: '/client_request/:client_request_id/:client_request_section',
            component: ClientRequest
          }
        ]
      },

      {
        path: '/bank_payment_list',
        name: 'bank_payment_list',
        props: true,
        component: BankPaymentList,
        redirect: '/bank_payment_list/payments',
        children: [
          {
            path: '/bank_payment_list/:bank_payment_list_section',
            name: 'bank_payment_list_section',
            component: BankPaymentList
          }
        ]
      },

      {
        path: '/bank_payment/:bank_payment_id',
        name: 'bank_payment',
        redirect: '/bank_payment/:bank_payment_id/info',
        component: BankPayment,
        children: [
          {
            name: 'bank_payment_section',
            path: '/bank_payment/:bank_payment_id/:bank_payment_section',
            component: BankPayment
          }
        ]
      },

      {
        path: '/invoice_list',
        name: 'invoice_list',
        props: true,
        component: InvoiceList,
        redirect: '/invoice_list/list',
        children: [
          {
            name: 'invoice_list_section',
            path: '/invoice_list/:invoice_list_section',
            component: InvoiceList
          },
        ]
      },

      {
        path: '/invoice/:invoice_id',
        name: 'invoice',
        redirect: '/invoice/:invoice_id/info',
        component: Invoice,
        children: [
          {
            name: 'invoice_section',
            path: '/invoice/:invoice_id/:invoice_section',
            component: Invoice
          }
        ]
      },

      {
        path: '/airalo_list',
        name: 'airalo_list',
        props: true,
        component: AiraloList,
        redirect: '/airalo_list/simcard_list',
        children: [
          {
            name: 'airalo_list_section',
            path: '/airalo_list/:airalo_list_section',
            component: AiraloList
          },
        ]
      },

      {
        path: '/airalo_simcard/:airalo_simcard_id',
        name: 'airalo_simcard',
        redirect: '/airalo_simcard/:airalo_simcard_id/info',
        component: Airalo,
        children: [
          {
            name: 'airalo_simcard_section',
            path: '/airalo_simcard/:airalo_simcard_id/:airalo_simcard_section',
            component: Airalo
          }
        ]
      },

      {
        path: '/storage_list',
        name: 'storage_list',
        props: true,
        component: StorageList,
        redirect: '/storage_list/devices',
        children: [
          {
            path: '/storage_list/:storage_list_section',
            name: 'storage_list_section',
            component: StorageList
          }
        ]
      },

      {
        path: '/snapshot_list',
        name: 'snapshot_list',
        props: true,
        component: SnapshotsList
      },

      {
        path: '/project_list',
        name: 'project_list',
        props: true,
        component: ProjectList
      },

      {
        path: '/project/:project_id',
        name: 'project_id',
        redirect: '/project/:project_id/info',
        component: Project,
        children: [
          {
            name: 'project_section',
            path: '/project/:project_id/:project_section',
            component: Project
          }
        ]
      },

      {
        path: '/settings',
        name: 'settings',
        component: Settings,
        redirect: '/settings/parameters',
        children: [
          {
            path: '/settings/:settings_section',
            name: 'settings_section',
            component: Settings
          }
        ]
      },
      {
        path: '/global_settings',
        name: 'global_settings',
        redirect: '/settings/parameters'
      },
      {
        path: '/monitoring_status',
        name: 'global_monitoring_status',
        redirect: '/settings/database_status'
      },
      {
        path: '/documentation',
        name: 'documentation',
        component: Documentation
      },
      {
        path: '/utilities',
        name: 'utilities',
        component: Utilities,
        redirect: '/utilities/commands',
        children: [
          {
            path: '/utilities/:utilities_section',
            name: 'utilities_section',
            component: Utilities
          }
        ]
      },
      {
        path: '/proxy_servers',
        name: 'proxy_servers',
        component: ProxyServers
      },
      {
        path: '/notification',
        name: 'notification',
        component: Notification,
        children: [
          {
            name: 'notification_section',
            path: '/notification/:notification_section',
            props: true,
            component: Notification
          }
        ]
      },
      {
        name: 'simcard_devices',
        path: '/simcard_devices/:simcard_devices_id',
        redirect: '/simcard_devices/:simcard_devices_id/profile',
        component: SimCardDevices,
        props: true,
        children: [
          {
            name: 'simcard_devices_section',
            path: '/simcard_devices/:simcard_devices_id/:simcard_devices_section',
            component: SimCardDevices
          }
        ]
      },
      {
        path: '/simcard_devices_list',
        name: 'simcard_devices_list',
        component: SimCardDevicesList
      },
      {
        path: '/simcard_devices_groups',
        name: 'simcard_devices_groups',
        component: SimCardDevicesGroups
      },


      //// Старый список с симкартами от операторов

      {
        path: '/communication_management',
        name: 'communication_management',
        redirect: '/communication_management/actions_history',
        component: CommunicationManagement,
        children: [
          {
            name: 'communication_management_section',
            path: '/communication_management/:communication_management_section',
            component: CommunicationManagement
          }
        ]
      },


      //// Тарифы и услуги

      {
        path: '/tariffication',
        name: 'tariffication',
        redirect: '/tariffication/tariffed_devices',
        props: true,
        component: Tariffication,
        children: [
          {
            name: 'tariffication_section',
            path: '/tariffication/:tariffication_section',
            props: true,
            component: Tariffication,
            children: [
              {
                name: 'tariffication_item',
                path: '/tariffication/:tariffication_section/:tariffication_item',
                props: true,
                component: Tariffication
              }
            ]
          },
        ]
      },

      {
        path: '/tariffed_device/:tariffed_device_id',
        name: 'tariffed_device',
        redirect: '/tariffed_device/:tariffed_device_id/info',
        component: TariffedDevice,
        children: [
          {
            name: 'tariffed_device_section',
            path: '/tariffed_device/:tariffed_device_id/:tariffed_device_section',
            component: TariffedDevice
          }
        ]
      },

      {
        path: '/tariff/:tariff_id',
        name: 'tariff_id',
        redirect: '/tariff/:tariff_id/info',
        component: Tariff,
        children: [
          {
            name: 'tariff_section',
            path: '/tariff/:tariff_id/:tariff_section',
            component: Tariff
          }
        ]
      },

      {
        path: '/traffic_packet_list',
        name: 'traffic_packet_list',
        redirect: '/traffic_packet_list/device_packet_items',
        props: true,
        component: TrafficPacketList,
        children: [
          {
            name: 'traffic_packet_list_section',
            path: '/traffic_packet_list/:traffic_packet_list_section',
            props: true,
            component: TrafficPacketList,
            children: [
              {
                name: 'traffic_packet_list_item',
                path: '/traffic_packet_list/:traffic_packet_list_section/:traffic_packet_list_item',
                props: true,
                component: TrafficPacketList
              }
            ]
          },
        ]
      },

      ////Cписок SimcardProfile

      {
        name: 'simcard_profile',
        path: '/simcard_profile/:simcard_profile_id',
        redirect: '/simcard_profile/:simcard_profile_id/profile',
        component: SimCardProfile,
        children: [
          {
            name: 'simcard_profile_section',
            path: '/simcard_profile/:simcard_profile_id/:simcard_profile_section',
            component: SimCardProfile
          }
        ]
      },

      {
        name: 'simcard_profile_list',
        path: '/simcard_profile_list',
        props: true,
        redirect: '/simcard_profile_list/sim_card_list',
        component: SimCardProfileList,
        children: [
          {
            name: 'simcard_profile_list_section',
            path: '/simcard_profile_list/:simcard_profile_list_section',
            component: SimCardProfileList
          }
        ]
      },

      ////Cписок EsimProfile
      {
        name: 'esim_profile',
        path: '/esim_profile/:esim_profile_id',
        redirect: '/esim_profile/:esim_profile_id/profile',
        component: EsimProfile,
        children: [
          {
            name: 'esim_profile_section',
            path: '/esim_profile/:esim_profile_id/:esim_profile_section',
            component: EsimProfile
          }
        ]
      },
      {
        path: '/esim_profile_list',
        name: 'esim_profile_list',
        component: EsimProfileList
      },

        //Remote Sim
      {
        path: '/remote_sim',
        name: 'remote_sim',
        redirect: '/remote_sim/remote_sim_list',
        component: RemoteSim,
        children: [
          {
            name: 'remote_sim_section',
            path: '/remote_sim/:remote_sim_section',
            component: RemoteSim
          }
        ]
      },

      //Diadoc
      {
        path: '/diadoc',
        name: 'diadoc',
        props: true,
        component: Diadoc,
        redirect: "/diadoc/documents",
        children: [
          {
            name: 'diadoc_section',
            path: '/diadoc/:diadoc_section',
            component: Diadoc
          }
        ]
      },
      {
        name: 'diadoc_document',
        path: '/diadoc_document/:diadoc_document_id',
        redirect: '/diadoc_document/:diadoc_document_id/info',
        component: DiadocDocument,
        children: [
          {
            name: 'diadoc_document_section',
            path: '/diadoc_document/:diadoc_document_id/:diadoc_document_section',
            component: DiadocDocument
          }
        ]
      },

      {
        path: '/services',
        name: 'services',
        redirect: '/services/blocked_simcard',
        props: true,
        component: Services,
        children: [
          {
            name: 'services_section',
            path: '/services/:services_section',
            props: true,
            component: Services
          },
        ]
      },

      {
        name: 'sim_task_list',
        path: '/sim_task_list',
        props: true,
        redirect: '/sim_task_list/task_list',
        component: SimTaskList,
        children: [
          {
            name: 'sim_task_list_section',
            path: '/sim_task_list/:sim_task_list_section',
            component: SimTaskList
          }
        ]
      },


      {
        path: '/sim_task/:sim_task_id',
        name: 'sim_task_id',
        redirect: '/sim_task/:sim_task_id/info',
        component: SimTask,
        children: [
          {
            name: 'sim_task_section',
            path: '/sim_task/:sim_task_id/:sim_task_section',
            component: SimTask
          }
        ]
      },
    ]
    return {
      path: '/',
      component: DashboardLayout,
      children: userPath
    }
  }
}
export default {MyRoute}
